import { FC } from "react";
import YellowCardSvg from "../../assets/yellow-card.svg";
import RedCardSvg from "../../assets/red-card.svg";
import { LineChart } from "components/charts/LineChart";
import { Text } from "components/common/Text";

export const CardsAndCorners: FC<{
  corners?: [number, number];
  yellowCards?: [number, number];
  redCards?: [number, number];
  onTarget?: [number, number];
  offTarget?: [number, number];
}> = ({
  corners = [0, 0],
  yellowCards = [0, 0],
  redCards = [0, 0],
  onTarget = [0, 0],
  offTarget = [0, 0],
}) => {
  const homeShotsTotal = (onTarget?.[0] || 0) + (offTarget?.[0] || 0);
  const awayShotsTotal = (onTarget?.[1] || 0) + (offTarget?.[1] || 0);

  return (
    <div className="mt-[3vw] mb-[2vw] flex w-full flex-col">
      <div className="flex w-full items-center justify-between gap-[2vw]">
        <div className="my-auto flex w-[4vw] flex-col gap-[0.5vw]">
          <FlagIcon />
          <span className="mx-auto text-white">
            <Text variant="chartValue">{corners[0]}</Text>
          </span>
        </div>
        <div className="my-auto flex w-[4vw] flex-col gap-[0.5vw]">
          <CardIcon icon={RedCardSvg} />
          <span className="mx-auto text-white">
            <Text variant="chartValue">{redCards[0]}</Text>
          </span>
        </div>
        <div className="my-auto flex w-[4vw] flex-col gap-[0.5vw]">
          <CardIcon icon={YellowCardSvg} />
          <span className="mx-auto text-white">
            <Text variant="chartValue">{yellowCards[0]}</Text>
          </span>
        </div>
        <div className="relative my-auto flex w-[40%] flex-col">
          <div className="mb-[0.6vw] text-center font-bold text-statisticTitle">
            <Text variant="chartTitle">Shot / On Target</Text>
          </div>
          <div className="flex w-full items-center justify-center gap-[0.5vw]">
            <span className="mx-auto text-white">
              <Text variant="chartValue">{homeShotsTotal}</Text>
            </span>
            <span className="mx-auto text-white">
              <Text variant="chartValue">/</Text>
            </span>
            <span className="mx-auto text-white">
              <Text variant="chartValue">{onTarget[0]}</Text>
            </span>
            <div className="min-w-[16vw] flex-1">
              <LineChart
                homeValue={onTarget[0]}
                awayValue={onTarget[1]}
                title=""
                hideTitle
                hideSides
              />
            </div>
            <span className="mx-auto text-white">
              <Text variant="chartValue">{onTarget[1]}</Text>
            </span>
            <span className="mx-auto text-white">
              <Text variant="chartValue">/</Text>
            </span>
            <span className="mx-auto text-white">
              <Text variant="chartValue">{awayShotsTotal}</Text>
            </span>
          </div>
        </div>
        <div className="my-auto flex w-[4vw] flex-col gap-[0.5vw]">
          <CardIcon icon={YellowCardSvg} />
          <span className="mx-auto text-white">
            <Text variant="chartValue">{yellowCards[1]}</Text>
          </span>
        </div>
        <div className="my-auto flex w-[4vw] flex-col gap-[0.5vw]">
          <CardIcon icon={RedCardSvg} />
          <span className="mx-auto text-white">
            <Text variant="chartValue">{redCards[1]}</Text>
          </span>
        </div>
        <div className="my-auto flex w-[4vw] flex-col gap-[0.5vw]">
          <FlagIcon isAway />
          <span className="mx-auto text-white">
            <Text variant="chartValue">{corners[1]}</Text>
          </span>
        </div>
      </div>
    </div>
  );
};

const CardIcon: FC<{ icon: string }> = ({ icon }) => (
  <div
    className="mx-auto h-[4vw] w-[4vw] bg-contain bg-center bg-no-repeat"
    style={{ backgroundImage: `url(${icon})` }}
  />
);

const FlagIcon: FC<{ isAway?: boolean }> = ({ isAway = false }) => (
  <div
    className={`relative mx-auto h-[4vw] w-[3vw] ${
      isAway ? "-scale-x-100" : ""
    }`}
  >
    <div className="absolute left-0 top-0 h-full w-[5%] bg-white" />
    <div
      className="absolute left-[5%] top-0 h-1/2 w-[95%]"
      style={{ background: isAway ? "var(--away-color)" : "var(--home-color)" }}
    />
  </div>
);
